import { render } from "./AdminReportDetails.vue?vue&type=template&id=17e89086&scoped=true"
import script from "./AdminReportDetails.vue?vue&type=script&lang=js"
export * from "./AdminReportDetails.vue?vue&type=script&lang=js"

import "./AdminReportDetails.vue?vue&type=style&index=0&id=17e89086&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e89086"]])

export default __exports__